var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9929 0C18.6221 0 23.9953 5.37321 23.9953 12.0024C23.9953 18.6315 18.6221 24 11.9976 24C5.36849 24 3.10941e-06 18.6268 3.10941e-06 12.0024C-0.00471851 5.37321 5.36848 0 11.9929 0Z",
    fill: "#8247E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3311_714",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 5,
    width: 16,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7746 5.19043H4.04688V18.9728H19.7746V5.19043Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3311_714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9257 9.38768C15.6376 9.22242 15.2694 9.22242 14.9436 9.38768L12.6489 10.7475L11.0907 11.6116L8.8385 12.9667C8.55049 13.1319 8.1822 13.1319 7.85641 12.9667L6.09524 11.8949C5.80722 11.7296 5.60419 11.3991 5.60419 11.0308V8.97218C5.60419 8.64166 5.76945 8.31587 6.09524 8.10812L7.85641 7.07881C8.14443 6.91355 8.51271 6.91355 8.8385 7.07881L10.5997 8.15062C10.8877 8.31587 11.0907 8.64639 11.0907 9.01467V10.3745L12.6489 9.46795V8.07035C12.6489 7.73983 12.4836 7.41404 12.1578 7.20629L8.881 5.27043C8.59298 5.10517 8.22469 5.10517 7.8989 5.27043L4.54183 7.24879C4.21604 7.41404 4.05078 7.74456 4.05078 8.07035V11.9374C4.05078 12.2679 4.21604 12.5937 4.54183 12.8014L7.86113 14.7373C8.14915 14.9025 8.51743 14.9025 8.84323 14.7373L11.0954 13.4199L12.6536 12.5134L14.9058 11.1961C15.1938 11.0308 15.5621 11.0308 15.8879 11.1961L17.649 12.2254C17.9371 12.3906 18.1401 12.7211 18.1401 13.0894V15.1481C18.1401 15.4786 17.9748 15.8044 17.649 16.0121L15.9304 17.0414C15.6424 17.2067 15.2741 17.2067 14.9483 17.0414L13.1824 16.0121C12.8944 15.8469 12.6913 15.5163 12.6913 15.1481V13.8307L11.1332 14.7373V16.0971C11.1332 16.4276 11.2985 16.7534 11.6243 16.9612L14.9436 18.897C15.2316 19.0623 15.5999 19.0623 15.9257 18.897L19.245 16.9612C19.533 16.7959 19.736 16.4654 19.736 16.0971V12.1876C19.736 11.8571 19.5707 11.5313 19.245 11.3235L15.9257 9.38768Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolCoin);
export default __webpack_public_path__ + "static/media/polCoin.82ec077fb32b8d99fcfa14587d07c741.svg";
export { ForwardRef as ReactComponent };